import LanguageSelector from '../Header/LanguageSelector/LanguageSelector';
import ThemeSelector from '../Header/ThemeSelector/ThemeSelector';
import './authPageHeader.less';

export default function AuthPageHeader() {
    return (
        <div className="auth-page-header">
            <ThemeSelector />
            <LanguageSelector />
        </div>
    );
}
